import {
  FeeOfferingDto,
  StandardOfferingDto,
  PackageOfferingDto,
} from "app/shared/model/EditPricelist";


export const isFeeOffering = (entry: any): entry is FeeOfferingDto =>
  !!entry && (entry.type === "Fee" || entry.offeringType === "fee" || entry.feeId != null);

export const isPackageOffering = (entry: any): entry is PackageOfferingDto =>
  !!entry &&
  (entry.type === "Package" ||
    entry.offeringType === "package" ||
    Array.isArray(entry.packageOfferingBreakdowns));

export const isStandardOffering = (entry: any): entry is StandardOfferingDto =>
  !!entry &&
  !isFeeOffering(entry) &&
  !isPackageOffering(entry) &&
  entry.productId != null &&
  Array.isArray(entry.pricePeriods);

export const isNonFeeOffering = (
  entry: any
): entry is StandardOfferingDto | PackageOfferingDto =>
  isStandardOffering(entry) || isPackageOffering(entry);

